import React, { useState } from 'react';
import { Alert, Button, Form, Spinner } from 'react-bootstrap';

import './login.css';
import { useLocation } from 'react-router';
import { Link, useNavigate } from 'react-router-dom';
import { api } from '../../index';

export default function Login() {
    const [credentials, setCredentials] = useState({ username: '', password: '' });
    const [error, setError] = useState<string | null>(null); // Initialize as null or empty string
    const [isLoading, setIsLoading] = useState(false); // New loading state
    const location = useLocation();
    const navigate = useNavigate();

    // This page does both login and register.
    const isLoginPath = location.pathname === '/login';

    const navLoc = () => {

        if (location.state && location.state.from)
            return `${location.state.from.pathname}`;

        return '/home';
    }

    const handleSubmit = async () => {
        setError(null);
        setIsLoading(true);

        try {
            if (isLoginPath) {
                await api.post('/auth/login', credentials, { withCredentials: true });

                localStorage.setItem("userData", JSON.stringify({ username: credentials.username }));
                navigate(navLoc());
            } else {
                await api.post('/auth/register', credentials);
                await api.post('/auth/login', credentials, { withCredentials: true });

                localStorage.setItem("userData", JSON.stringify({ username: credentials.username }));
                navigate(navLoc());
            }
        } catch (e: any) {
            if (e.response && e.response.data && e.response.data.message) {
                setError(e.response.data.message);
            } else {
                setError(
                    isLoginPath ? 'Login failed. Please try again.' : 'Registration failed. Please try again.'
                );
            }
        } finally {
            setIsLoading(false); // Reset loading state
        }
    };

    return (
        // <Container className='py-5 d-flex justify-content-center align-items-center flex-grow-1'>
        <div className='p-4 border rounded shadow-lg my-auto' style={{ maxWidth: '400px', width: '100%' }}>
            <h2 className='text-center mb-4'>{isLoginPath ? 'Login' : 'Register'}</h2>

            {error && (
                <Alert variant='danger' className='mb-3'>
                    {error}
                </Alert>
            )}

            <Form onSubmit={(e) => { e.preventDefault(); handleSubmit(); }}>
                <Form.Group className='mb-3' controlId='formBasicUsername'>
                    <Form.Label>Username</Form.Label>
                    <Form.Control
                        type='text'
                        placeholder='Enter username'
                        onChange={(e) => {
                            setCredentials({ ...credentials, username: e.target.value });
                        }}
                        value={credentials.username}
                        required
                    />
                </Form.Group>

                <Form.Group className='mb-4' controlId='formBasicPassword'>
                    <Form.Label>Password</Form.Label>
                    <Form.Control
                        type='password' // Changed to password type
                        placeholder='Password'
                        onChange={(e) => {
                            setCredentials({ ...credentials, password: e.target.value });
                        }}
                        value={credentials.password}
                        required
                    />
                </Form.Group>

                <Button
                    variant='primary'
                    type='submit' // Changed to type='submit'
                    className='w-100 mb-3'
                    disabled={isLoading} // Disable button while loading
                >
                    {isLoading ? (
                        <>
                            <Spinner
                                as='span'
                                animation='border'
                                size='sm'
                                role='status'
                                aria-hidden='true'
                                className='me-2'
                            />
                            Loading...
                        </>
                    ) : (
                        isLoginPath ? 'Login' : 'Register'
                    )}
                </Button>
            </Form>

            <p className='text-center mt-3'>
                {isLoginPath ? (
                    <>
                        Don't have an account? <Link to='/register'>Register here</Link>
                    </>
                ) : (
                    <>
                        Already have an account? <Link to='/login'>Login here</Link>
                    </>
                )}
            </p>
        </div>
        // </Container>
    );
}